import { Typography, Show } from 'shared';
import { Nullable } from 'shared_DEPRECATED/types';
import { dateUtils } from 'shared_DEPRECATED/utils';

type SessionsTableDateCellProps = {
  value: Nullable<string>;
};

export const SessionsTableDateCell = ({
  value: sessionDate,
}: SessionsTableDateCellProps) => {
  return (
    <Show when={!!sessionDate}>
      <Typography
        type="small"
        color="gray"
        fontWeight="regular"
        dataTestid="session-date-cell"
      >
        {dateUtils.abbreviatedMonthDate(sessionDate)}
      </Typography>
    </Show>
  );
};
